"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckbox = exports.StyledRadioButton = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_checkbox_1 = require("@hopin-team/ui-checkbox");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_radio_buttons_1 = require("@hopin-team/ui-radio-buttons");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var disabled_1 = require("./disabled");

var error_1 = require("./error");

var focus_1 = require("./focus");

var hover_1 = require("./hover");

var selected_1 = require("./selected");

var area = ui_blocks_1.INTERACTIVE.area;
exports.StyledRadioButton = (0, styled_components_1.default)(ui_radio_buttons_1.RadioButton)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  border: ", ";\n  padding: ", ";\n\n  ", " {\n    width: 100%;\n    padding-left: 0;\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  ", " {\n    padding-left: 0;\n  }\n\n  & input[type='radio'] {\n    height: 100%;\n    width: 100%;\n    top: 0;\n    cursor: pointer;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  border: ", ";\n  padding: ", ";\n\n  ", " {\n    width: 100%;\n    padding-left: 0;\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  ", " {\n    padding-left: 0;\n  }\n\n  & input[type='radio'] {\n    height: 100%;\n    width: 100%;\n    top: 0;\n    cursor: pointer;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), area, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
}, function (_a) {
  var withSubtitle = _a.withSubtitle,
      hasMedia = _a.hasMedia;
  return hasMedia ? '1rem' : withSubtitle ? '0.5rem 1rem' : '1rem';
}, ui_radio_buttons_1.Label, ui_radio_buttons_1.LabelFlex, function (_a) {
  var selected = _a.selected;
  return selected ? selected_1.selectedStyles : hover_1.hoverStyles;
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', error_1.errorStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isDisabled', disabled_1.disabledStyles);
}, focus_1.focusStyles);
exports.StyledCheckbox = (0, styled_components_1.default)(ui_checkbox_1.Checkbox)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  border: ", ";\n  padding: ", ";\n\n  ", " {\n    width: 100%;\n  }\n\n  & input[type='checkbox'] {\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  border: ", ";\n  padding: ", ";\n\n  ", " {\n    width: 100%;\n  }\n\n  & input[type='checkbox'] {\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), area, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.DEFAULT_BORDER', theme);
}, function (_a) {
  var withSubtitle = _a.withSubtitle,
      hasMedia = _a.hasMedia;
  return hasMedia ? '1rem' : withSubtitle ? '0.5rem 1rem' : '1rem';
}, ui_checkbox_1.Label, function (_a) {
  var checked = _a.checked;
  return checked ? selected_1.selectedStyles : hover_1.hoverStyles;
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'hasErrors', error_1.errorStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isDisabled', disabled_1.disabledStyles);
}, focus_1.focusStyles);
var templateObject_1, templateObject_2;